import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MydocumentsItemAdapterService } from '../core/http/adapters/mydocuments-item/mydocuments-item.service';
import { TealiumTrackingService } from '../core/services/tealium-tracking.service';
import { UtagHelperService } from '../core/services/utag-helper.service';
import { NavigationEnd, Router } from '@angular/router';
import { SessionType } from '../wizard/export/enum/session-type.enum';

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['./complete.component.scss'],
})
export class CompleteComponent implements OnInit {
  sessionType!: string;
  isOCIAribaRole!: boolean;
  app_name!: string;
  site_country!: string;
  site_language!: string;

  constructor(
    private tealium: TealiumTrackingService,
    private utagHelperService: UtagHelperService,
    public mydocumentsItemAdapterService: MydocumentsItemAdapterService,
    private location: Location,
    private router: Router
  ) {
    const elements = document.querySelectorAll('.eh-headline-01');

    elements.forEach((element) => {
      element.remove();
    });

    this.app_name = this.utagHelperService.getAppName();
    this.site_country = this.utagHelperService.getCountry();
    this.site_language = this.utagHelperService.getLanguage();

    if (this.mydocumentsItemAdapterService.sessionType === SessionType.QUOTE) {
      this.sessionType = 'quotes';
    } else {
      this.sessionType = 'orders';
    }

    this.isOCIAribaRole =
      this.mydocumentsItemAdapterService.customer_subrole.toLowerCase() ==
      'Nebp-Customer-OCI-Ariba'.toLowerCase();
    window.scrollTo(0, 0);
  }

  ngOnInit(): void {
    const pageName =
      this.app_name +
      '.' +
      this.site_country +
      '.' +
      this.site_language +
      '.' +
      'my endress+hauser' +
      '.' +
      this.sessionType +
      '.' +
      'product document wizard' +
      '.' +
      'done!';

    const isLoggedIn = document.getElementsByClassName('Is-logged-in');
    let loggedIn;
    if (isLoggedIn) {
      loggedIn = 'logged_in';
    } else {
      loggedIn = '';
    }

    this.tealium.view({
      app_name: this.app_name,
      site_country: this.site_country,
      site_language: this.site_language,
      site_h1: 'my endress+hauser',
      site_h2: this.sessionType,
      site_h3: 'product document wizard',
      site_h4: 'done!',
      login_status_per_page: loggedIn,
      customer_role: this.mydocumentsItemAdapterService.customer_role,
      customer_subrole: this.mydocumentsItemAdapterService.customer_subrole,
      login_status: loggedIn,
      page_name: pageName,
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.location.href =
          this.mydocumentsItemAdapterService.hookUrl ??
          '/shop#AccountOverview:';
      }
    });
  }

  navigateBack() {
    const eventId =
      this.app_name +
      '.' +
      this.site_country +
      '.' +
      this.site_language +
      '.' +
      'my endress+hauser' +
      '.' +
      this.sessionType +
      '.' +
      'product document wizard' +
      '.' +
      'Done!' +
      '.' +
      'content_link' +
      '.' +
      'Close and return';
    if (this.mydocumentsItemAdapterService.hookUrl) {
      this.tealium.link({
        event_name: 'content_link',
        event_linkname: 'Close and return',
        event_subtype: 'Close and return',
        event_id: eventId,
      });
      location.href = this.mydocumentsItemAdapterService.hookUrl;
    } else {
      this.tealium.link({
        event_name: 'content_link',
        event_linkname: 'Close and return',
        event_subtype: 'Close and return',
        event_id: eventId,
      });
      this.location.back();
    }
  }
}
